import { render } from "./nova-referencia.vue?vue&type=template&id=f27b2250&scoped=true"
import script from "./nova-referencia.vue?vue&type=script&lang=js"
export * from "./nova-referencia.vue?vue&type=script&lang=js"

import "./nova-referencia.vue?vue&type=style&index=0&id=f27b2250&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27b2250"]])

export default __exports__